import formatISO from 'date-fns/formatISO';

import useAxios from '../../../library/axios'; 

import IBankPolicy, {IBankPolicySearch} from '../model/BankPolicy';

 

const _ = () => {

    const axios = useAxios();

    const saveBankPolicy = async (bankPolicy: IBankPolicy)  =>       
        await (await axios.post('/crm/bankPolicy/save', bankPolicy)).data;   

    const getBankPolicy = async (policyID  : number )  => {
        const {data} = (await axios.get(`/crm/bankPolicy/getBankPolicy/${policyID}`));
        
        return await data;
    }
    
    const getBankPoliciesList = async (criteria  : IBankPolicySearch )  => {
        const { groupPolicyID, productCode, agencyCode, policyStatus, isPolicyTransmited,
            personNameNIC,payorPersonNameNIC ,effectiveDateStart, effectiveDateEnd} = criteria;
        // const {data} = (await axios.get(`/crm/bankPolicy/getBankPoliciesList/?groupPolicyID=${groupPolicyID}&productCode=${productCode}&`+
        // `agencyCode=${agencyCode}&policyStatus=${policyStatus}&isPolicyTransmited=${isPolicyTransmited}&personNameNIC=${personNameNIC}&payorPersonNameNIC=${payorPersonNameNIC}&`+
        // `effectiveDateStart=${effectiveDateStart.toISOString()}&effectiveDateEnd=${effectiveDateEnd.toISOString()}`));

        const effectiveDateStartISO = formatISO(effectiveDateStart, {representation: 'date'});
        const effectiveDateEndISO = formatISO(effectiveDateEnd, {representation: 'date'});

        const {data} = (await axios.get(`/crm/bankPolicy/getBankPoliciesList/?groupPolicyID=${groupPolicyID}&productCode=${productCode}&`+
        `agencyCode=${agencyCode}&policyStatus=${policyStatus}&personNameNIC=${personNameNIC}&payorPersonNameNIC=${payorPersonNameNIC}&`+
        `isPolicyTransmited=${isPolicyTransmited}&effectiveDateStart=${effectiveDateStartISO}&effectiveDateEnd=${effectiveDateEndISO}`));
     
        

        // const {data} = (await axios.get(`/crm/bankPolicy/getBankPoliciesList/?groupPolicyID=${groupPolicyID}&productCode=${productCode}&`+
        // `agencyCode=${agencyCode}&policyStatus=${policyStatus}&personNameNIC=${personNameNIC}&payorPersonNameNIC=${payorPersonNameNIC}`));

        return await data;
      }

    const getBankPoliciesFilterList = async (groupPolicyID: number, policyStatus: string ,filter: string )  => {
    
    const {data} = (await axios.get(`/crm/bankPolicy/getBankPoliciesFilterList/?groupPolicyID=${groupPolicyID}&policyStatus=${policyStatus}&filter=${filter}`));
    return await data;
    }

    const evaluateBankPolicyValue = async (bankPolicy: IBankPolicy)  => 
        await (await axios.post('/crm/bankPolicy/evaluateBankPolicyValue', bankPolicy)).data;         

    return {
        saveBankPolicy,
        getBankPolicy,
        evaluateBankPolicyValue,

        getBankPoliciesList,
        getBankPoliciesFilterList      
    } 
}

export default _;